import cx from "classnames";

import { useAuth } from "utils/auth";
import styles from "./NavAccountLinks.module.scss";

interface Props {
  navRef: React.MutableRefObject<HTMLDivElement>;
  navIsExpanded: boolean;
  searchIsExpanded: boolean;
  closeNav: () => void;
  closeDesktopSearch: () => void;
}

const NavAccountLinks = ({
  navRef,
  navIsExpanded,
  searchIsExpanded,
  closeNav,
  closeDesktopSearch,
}: Props) => {
  const { isLoggedIn, hasPaywallAccess } = useAuth();

  return (
    <ul className={styles.root}>
      <li className={styles.navListItem}>
        <a
          data-action={isLoggedIn ? "Open Account" : "Sign In"}
          href={
            isLoggedIn
              ? "https://accounts.theatlantic.com/accounts/details/"
              : "https://accounts.theatlantic.com/login/"
          }
          className={cx(
            styles.navLink,
            // Only hide the sign in link on mobile if the nav isn't expanded
            !navIsExpanded && styles.hideOnMobile
          )}
        >
          {isLoggedIn ? "My Account" : "Sign In"}
        </a>
      </li>
      <li className={styles.navListItem}>
        <a
          data-action={hasPaywallAccess ? "Give a Gift" : "Subscribe"}
          href={
            hasPaywallAccess
              ? "https://accounts.theatlantic.com/products/gift/"
              : "https://www.theatlantic.com/subscribe/navbar/"
          }
          className={styles.subscribe}
          onBlur={(event: React.FocusEvent<HTMLAnchorElement>) => {
            // If the user tabs back into the nav, we want to keep it open
            const focusedBackInNav = navRef.current.contains(
              event.relatedTarget as Node
            );

            // Close the nav and search after tabbing out of the last nav item
            if (navIsExpanded && !focusedBackInNav) {
              closeNav();
            }

            if (searchIsExpanded && !focusedBackInNav) {
              closeDesktopSearch();
            }
          }}
        >
          {hasPaywallAccess ? "Give a Gift" : "Subscribe"}
        </a>
      </li>
    </ul>
  );
};

export default NavAccountLinks;
